module.exports = __webpack_public_path__ + "static/media/application-5-crop-mobile.6819dd9e.jpg";